'use strict';

angular.module('shiftTraderApp')
    .service('AvailabilityService', ['Session', 'TimeService', function (Session, TimeService) {
      var decodeDayOfWeek = function(d) {
        return ['Su','Mo','Tu','We','Th','Fr','Sa'][d];
      };

      var getAvailabilityViolationDescription = function(violation) {
        var txt = '';

        if (violation.type === 'weekly') {
          return 'Unavailable ' + TimeService.minimalMomentFormat(violation.data.start, true) + ' to ' + TimeService.minimalMomentFormat(violation.data.end, true);
        } else if (violation.type === 'single') {
          if (violation.approved) {
            txt = 'Approved ';
          } else {
            txt = 'Pending ';
          }

          txt += TimeService.minimalIntervalTimeFormat(violation.data.start.twix(violation.data.end)).strings.interval;
          return txt;
        } else {
          return 'Unavailable';
        }
      };


      var processAvailabilityForUser = function(user, wp_twix) {
        var unavailabilityMultiplier = 1; // weight of unavailability minutes
        var unavailabilityLedge = 60;     // weight added if even 1 minute is unavailable
        var noAvailabilityFactor = 0.125; // weight of no-availability minutes
        var availabilityRulesToCheck = []; // rules to check against (weekly + single)
        var violations = []; //an array of all violations found for wp_twix -vs- availability(weekly) + time_off_rules(single)
        var cumMinuteCounter = 0; // counts number of minutes in a day that are no-availability
        var totalMinutesInShift = wp_twix.length('minutes'); // minutes in twix being tested
        var wpTwixDayOfWeek = wp_twix.start.day(); // dayOfWeek of twix.start
        var daysOfWeekToAccept; // array of daysOfWeek to accept when processing availability rule (not time off)
        var hasAvailSet = false; // do they have an availability set?
        var hasPositiveSetRules = false; // do they have availability set rules where avail=true
        var logIt = false; // Debugging flag

        if (logIt) {
          console.log('logIt: in processAvailabilityForUser', user.name, user.id);
          console.log('logIt: wp_twix incoming: ', wp_twix.start.format(), wp_twix.end.format());
        }

        var effectiveAvailabilitySet = lodash.find(user.availability_sets, function(availSet) {
          return availSet.$isInEffect(wp_twix.start) && availSet.$isApproved() && availSet.active;
        });

        // loop over availability and do an intersection with wp_twix...
        // should try to maximize this relative to the length of the wp_twix
        if (lodash.isUndefined(effectiveAvailabilitySet)) {
          if (logIt) {
            console.log('logIt: no availability_sets for user');
          }

          // if they have no availability set only weight their gray availability half as badly;
          noAvailabilityFactor = noAvailabilityFactor / 2.0;
        } else {
          hasAvailSet = true;
          hasPositiveSetRules = lodash.some(effectiveAvailabilitySet.availability_rules, function(rule) {
            return rule.avail;
          });

          // if they have a set and they don't have positive availability rules then don't punish them much for it.
          // someone with positive rules should come out just a bit ahead
          if (hasAvailSet && !hasPositiveSetRules) {
            noAvailabilityFactor = noAvailabilityFactor / 4.0;
          }

          // if there is an effective availability set, then add those rules onto availabilityRulesToCheck
          availabilityRulesToCheck.push.apply(availabilityRulesToCheck, effectiveAvailabilitySet.availability_rules);
        }

        if(wpTwixDayOfWeek === 6) {
          daysOfWeekToAccept = [5, 6, 0];
        } else if (wpTwixDayOfWeek === 0) {
          daysOfWeekToAccept = [6, 0, 1];
        } else {
          daysOfWeekToAccept = [wpTwixDayOfWeek - 1, wpTwixDayOfWeek, wpTwixDayOfWeek + 1];
        }

        var availabilityToSearch = lodash.filter(lodash.flattenDeep([user.time_off_rules, availabilityRulesToCheck]), function(ar) {
          return (lodash.includes(daysOfWeekToAccept, ar.day_of_week) || (ar._type === 'single')) && ar.active;
        });

        if (logIt) {
          console.log('logIt: availabilityToSearch:', availabilityToSearch);
        }

        //for each availability_rule calculate the intersection with wp_twix (if it overlaps)
        // if no overlap return 0. if overlap return weighted value representing type of overlap
        var intersection = lodash.map(availabilityToSearch, function(rule) {
          if (logIt) {
            console.log('logIt: ruleId = ', rule.id, 'day_of_week = ', rule.day_of_week);
          }
          var currWeek, ruleWeek, modRule;
          currWeek = wp_twix.start.week(); // TODO: Should this be start explicitly?
          if (currWeek !== rule.range_twix.start.week()) {
            rule.$setStartEnd(wp_twix.start);
          }
          ruleWeek = rule.range_twix.start.week();
          if (logIt) {
            console.log('logIt: currWeek: ', currWeek + '; ruleWeek: ', ruleWeek, currWeek !== ruleWeek, rule._type === 'weekly');
            console.log('logIt: currWeekEnd: ', wp_twix.end.week(), '; ruleWeekEnd: ', rule.range_twix.end.week());
          }

          if (rule._type === 'weekly' && wpTwixDayOfWeek === 6 && rule.day_of_week === 0) {
          //in the case that the twix is in this week and the rule is in next week,
          //  bump the modRule to the following week
            var newStart, newEnd;
            newStart = moment(rule.start).add(1, 'weeks');
            newEnd = moment(rule.end).add(1, 'weeks');
            modRule = moment(newStart).twix(newEnd);
            if (logIt) {
              console.log('logIt: modRule result=', modRule.format());
            }
          } else if (rule._type === 'weekly' && wpTwixDayOfWeek === 0 && rule.day_of_week === 6) {
            var newStart, newEnd;
            newStart = moment(rule.start).subtract(1, 'weeks');
            newEnd = moment(rule.end).subtract(1, 'weeks');
            modRule = moment(newStart).twix(newEnd);
            if (logIt) {
              console.log('logIt: modRule result=', modRule.format());
            }
          } else {
            modRule = rule.range_twix;
          }

          if (logIt) {
            console.log('logIt: wp_twix', wp_twix.start.format(), wp_twix.end.format(), 'modRule', modRule.start.format(), modRule.end.format());
            console.log('logIt: overlap? ', wp_twix.overlaps(modRule), wp_twix.intersection(modRule).format());
          }

          if (wp_twix.overlaps(modRule)) {
            var inter = wp_twix.intersection(modRule);
            var theIntersectionMinutes = Math.abs(inter.length('minutes'));
            cumMinuteCounter += theIntersectionMinutes;
            if (logIt) {
              console.log('logIt: inter', inter.format(), 'interMinutes', theIntersectionMinutes);
            }
            if (rule.avail || theIntersectionMinutes === 0) {
              return 0;
            } else {
              violations.push({
                data: rule._type === 'weekly' ? inter : rule.range_twix,
                avail: 'false',
                type: rule._type,
                approved: rule._type === 'weekly' ? true : (!lodash.isNull(rule.approved_by) && rule.active),
                reason: (function() {
                  if (rule._type === 'weekly') {
                    var effectiveSetId = effectiveAvailabilitySet ? effectiveAvailabilitySet.id : undefined;
                    if (!lodash.isUndefined(rule.$getMessageForSetId(effectiveSetId))) {
                      var entry = rule.$getMessageForSetId(effectiveSetId);
                      if (!lodash.isUndefined(entry.text) && entry.user && entry.user.id === rule.user_id) {
                        return {
                          created_at: moment.utc(entry.created_at).tz(Session.getTimezone()),
                          text: entry.text,
                          availability_set_id: entry.availability_set_id,
                          approved_at: effectiveAvailabilitySet.approved_at,
                          approved_by: effectiveAvailabilitySet.approved_by_id
                        };
                      }
                    } else {
                      return {
                        text: 'None given',
                        approved_at: effectiveAvailabilitySet.approved_at,
                        approved_by: effectiveAvailabilitySet.approved_by_id
                      };
                    }
                  } else {
                    if (rule.comment && rule.comment.length > 0) {
                      return {
                        created_at: rule.created_at,
                        text: rule.comment,
                        approved_at: moment.utc(rule.approved_at).tz(Session.getTimezone()),
                        approved_by: rule.approved_by
                      };
                    }
                  }
                  return {};
                }())
              });
              return theIntersectionMinutes * unavailabilityMultiplier + unavailabilityLedge;
            }
          } else {
            return 0;
          }
        });

        //yellow minutes are no-availability minutes
        // by definition is totalMinutes in the shift minus the number of minutes we had overlap with
        var yellowAvailabilityInMinutes = totalMinutesInShift - cumMinuteCounter;

        if (yellowAvailabilityInMinutes > 0) {
          violations.push({
            avail: 'between',
            data: yellowAvailabilityInMinutes
          });
        }

        var weightedIntersection;
        //console.log('totalMinutes - cumMinuteCounter = ' + totalMinutesInShift + ' - ' + cumMinuteCounter + ' = ' + yellowAvailabilityInMinutes);
        if(intersection.length > 0) {
          weightedIntersection = yellowAvailabilityInMinutes * noAvailabilityFactor + lodash.reduce(intersection, function(sum, num) {
            return sum + num;
          });
        } else {
          weightedIntersection = yellowAvailabilityInMinutes * noAvailabilityFactor;
        }
        //sum up all of the weights and return one integer

        return {
          weight: weightedIntersection,
          data: violations,
          type: 'AvailabilityIntersection'
        };
      };

      return {
        decodeDayOfWeek: decodeDayOfWeek,
        getAvailabilityViolationDescription: getAvailabilityViolationDescription,
        processAvailabilityForUser: processAvailabilityForUser
      };

    }]);
